import { PercentileRankingsChartDto } from 'types/CodegenReportTypes';
import { UnitSystem } from 'types/StartupTypes';

export type PercentileRankingConfig = {
  unitLabel: string | ((unitSystem: UnitSystem) => string) | undefined;
  fractionDigits: number | undefined;
  leadingZero: boolean | undefined;
};

export const percentileRankings: Record<keyof PercentileRankingsChartDto, PercentileRankingConfig> = {
  avgExitSpeed: { unitLabel: (us) => (us === 'Metric' ? 'kph' : 'mph'), fractionDigits: 1, leadingZero: true },
  hardHitPercent: { unitLabel: '%', fractionDigits: 1, leadingZero: true },
  barrelPercent: { unitLabel: '%', fractionDigits: 1, leadingZero: true },
  slugging: { unitLabel: undefined, fractionDigits: 3, leadingZero: false },
  strikeoutPercent: { unitLabel: '%', fractionDigits: 1, leadingZero: true },
  baseOnBallsPercent: { unitLabel: '%', fractionDigits: 1, leadingZero: true },
  whiffPercent: { unitLabel: '%', fractionDigits: 1, leadingZero: true },
  chasePercent: { unitLabel: '%', fractionDigits: 1, leadingZero: true },
  battingAverage: { unitLabel: undefined, fractionDigits: 3, leadingZero: false },
  fastballVelocity: { unitLabel: (us) => (us === 'Metric' ? 'kph' : 'mph'), fractionDigits: 1, leadingZero: true },
  fastballSpin: { unitLabel: 'rpm', fractionDigits: 0, leadingZero: false },
  maxExitSpeed: { unitLabel: (us) => (us === 'Metric' ? 'kph' : 'mph'), fractionDigits: 1, leadingZero: true },
};
